import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@dotcom/crown-ui';
import classNames from 'classnames';
import { FooterContentProps } from '../scale-drawer-types';
import styles from '../scale-drawer.module.scss';

export const FooterContent = ({ onCancel, onApply }: FooterContentProps): React.ReactElement => {
  const { t } = useTranslation();
  return (
    <div className={styles['footer-wrapper']}>
      <Button className={classNames(styles['footer-buttons'])} onClick={onCancel} variant={'secondary'}>
        {t('footerContent.cancel')}
      </Button>
      <Button className={classNames(styles['footer-buttons'])} onClick={onApply} variant={'primary'}>
        {t('footerContent.apply')}
      </Button>
    </div>
  );
};
